(function () {
  var usStateNames = {
    al: "alabama",
    ak: "alaska",
    az: "arizona",
    ar: "arkansas",
    ca: "california",
    co: "colorado",
    ct: "connecticut",
    de: "delaware",
    fl: "florida",
    ga: "georgia",
    hi: "hawaii",
    id: "idaho",
    il: "illinois",
    in: "indiana",
    ia: "iowa",
    ks: "kansas",
    ky: "kentucky",
    la: "louisiana",
    me: "maine",
    md: "maryland",
    ma: "massachusetts",
    mi: "michigan",
    mn: "minnesota",
    ms: "mississippi",
    mo: "missouri",
    mt: "montana",
    ne: "nebraska",
    nv: "nevada",
    nh: "new hampshire",
    nj: "new jersey",
    nm: "new mexico",
    ny: "new york",
    nc: "north carolina",
    nd: "north dakota",
    oh: "ohio",
    ok: "oklahoma",
    or: "oregon",
    pa: "pennsylvania",
    ri: "rhode island",
    sc: "south carolina",
    sd: "south dakota",
    tn: "tennessee",
    tx: "texas",
    ut: "utah",
    vt: "vermont",
    va: "virginia",
    wa: "washington",
    wv: "west virginia",
    wi: "wisconsin",
    wy: "wyoming",
    dc: "district of columbia",
  };

  function normalizeSearchValue(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function compactSearchValue(value) {
    return normalizeSearchValue(value).replace(/\s+/g, "");
  }

  function splitList(value) {
    if (Array.isArray(value)) return value;

    return String(value || "")
      .split(/[,;\n|•·]+|\s+\?\s+/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function toNumber(value) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : null;
  }

  function calculateDistanceMiles(lat1, lng1, lat2, lng2) {
    var earthRadiusMiles = 3958.8;
    var latDelta = ((lat2 - lat1) * Math.PI) / 180;
    var lngDelta = ((lng2 - lng1) * Math.PI) / 180;
    var a =
      Math.sin(latDelta / 2) * Math.sin(latDelta / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(lngDelta / 2) *
        Math.sin(lngDelta / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadiusMiles * c;
  }

  function getStateQuery(query) {
    var normalizedQuery = normalizeSearchValue(query);
    var stateCode;

    if (!normalizedQuery) return "";
    if (usStateNames[normalizedQuery]) return usStateNames[normalizedQuery];

    for (stateCode in usStateNames) {
      if (usStateNames[stateCode] === normalizedQuery) return normalizedQuery;
    }

    return "";
  }

  function normalizeUrl(url) {
    var value = String(url || "").trim();

    if (!value) return "";
    if (value.indexOf("://") !== -1 || value.charAt(0) === "/") return value;
    if (value.indexOf("pages/") === 0) return "/" + value;
    return "/pages/" + value;
  }

  function parseCityHubs(rawHubs) {
    return (rawHubs || [])
      .map(function (hub) {
        var title = hub.title || hub.cityName || hub.name || "";
        var url = normalizeUrl(hub.url || hub.cityUrl || hub.cityPageUrl || "");

        return {
          title: title,
          cityName: title,
          url: url,
          cityUrl: url,
          image: hub.image || hub.cityImage || "",
          description: hub.description || hub.citySmallDescription || "",
          state: hub.state || "",
          stateCode: hub.stateCode || "",
          lat: toNumber(hub.lat || hub.latitude),
          lng: toNumber(hub.lng || hub.longitude),
        };
      })
      .filter(function (hub) {
        return !!(hub.title && hub.url);
      });
  }

  function getHubSearchText(hub) {
    return normalizeSearchValue(
      [
        hub.title,
        hub.cityName,
        hub.state,
        hub.stateCode,
        usStateNames[normalizeSearchValue(hub.stateCode)],
      ]
        .filter(Boolean)
        .join(" ")
    );
  }

  function findCityHubForMapping(mapping, cityHubs) {
    var parentUrl = normalizeUrl(mapping.parentCityPageUrl || "");
    var parentTitle = normalizeSearchValue(mapping.parentCityPageTitle || "");
    var searchCity = normalizeSearchValue(mapping.searchCity || mapping.displayName || "");

    return (
      (cityHubs || []).find(function (hub) {
        return parentUrl && normalizeUrl(hub.url || hub.cityUrl) === parentUrl;
      }) ||
      (cityHubs || []).find(function (hub) {
        return parentTitle && normalizeSearchValue(hub.title || hub.cityName) === parentTitle;
      }) ||
      (cityHubs || []).find(function (hub) {
        return searchCity && normalizeSearchValue(hub.title || hub.cityName) === searchCity;
      }) ||
      null
    );
  }

  function parseLocationMappings(rawMappings, cityHubs) {
    return (rawMappings || [])
      .map(function (mapping) {
        var zipCodes = splitList(mapping.zipCodes);
        var aliases = splitList(mapping.searchAliases);
        var neighborhoods = splitList(mapping.neighborhoods);
        var hub = findCityHubForMapping(mapping, cityHubs);
        var url = normalizeUrl(mapping.parentCityPageUrl || (hub && hub.url) || "");
        var title =
          mapping.parentCityPageTitle ||
          (hub && hub.title) ||
          mapping.searchCity ||
          mapping.displayName ||
          "";
        var lat = toNumber(mapping.lat || mapping.latitude);
        var lng = toNumber(mapping.lng || mapping.longitude);

        if (lat === null && hub) lat = hub.lat;
        if (lng === null && hub) lng = hub.lng;

        return {
          searchCity: mapping.searchCity || mapping.displayName || title,
          displayName: mapping.displayName || mapping.searchCity || title,
          state: mapping.state || "",
          stateCode: mapping.stateCode || "",
          zipCodes: zipCodes,
          searchAliases: aliases,
          neighborhoods: neighborhoods,
          parentCityPageTitle: title,
          parentCityPageUrl: url,
          isHubCity: mapping.isHubCity === true || String(mapping.isHubCity) === "true",
          lat: lat,
          lng: lng,
          hub: hub || {
            title: title,
            cityName: title,
            url: url,
            cityUrl: url,
            state: mapping.state || "",
            stateCode: mapping.stateCode || "",
            lat: lat,
            lng: lng,
          },
        };
      })
      .filter(function (mapping) {
        return !!(mapping.searchCity && mapping.parentCityPageUrl);
      });
  }

  function getMappingTerms(mapping) {
    return [
      mapping.searchCity,
      mapping.displayName,
      mapping.state,
      mapping.stateCode,
      usStateNames[normalizeSearchValue(mapping.stateCode)],
      mapping.parentCityPageTitle,
    ]
      .concat(mapping.zipCodes || [])
      .concat(mapping.searchAliases || [])
      .concat(mapping.neighborhoods || [])
      .filter(Boolean);
  }

  function scoreMapping(query, mapping) {
    var normalizedQuery = normalizeSearchValue(query);
    var compactQuery = compactSearchValue(query);
    var stateQuery = getStateQuery(query);
    var terms = getMappingTerms(mapping);
    var score = 0;
    var kind = "";

    terms.forEach(function (term) {
      var normalizedTerm = normalizeSearchValue(term);
      var compactTerm = compactSearchValue(term);

      if (!normalizedTerm) return;

      if (compactQuery && compactQuery === compactTerm) {
        if ((mapping.zipCodes || []).indexOf(term) !== -1) {
          score = Math.max(score, 130);
          kind = "zip";
        } else if ((mapping.searchAliases || []).indexOf(term) !== -1) {
          score = Math.max(score, 120);
          kind = "alias";
        } else {
          score = Math.max(score, 110);
          kind = "city";
        }
      } else if (
        normalizedQuery.length >= 3 &&
        (normalizedTerm.indexOf(normalizedQuery) !== -1 ||
          normalizedQuery.indexOf(normalizedTerm) !== -1)
      ) {
        score = Math.max(score, 70);
        kind = kind || "broad";
      }
    });

    if (
      stateQuery &&
      (normalizeSearchValue(mapping.state) === stateQuery ||
        usStateNames[normalizeSearchValue(mapping.stateCode)] === stateQuery)
    ) {
      score = Math.max(score, 80);
      kind = "state";
    }

    return {
      score: score,
      kind: kind,
    };
  }

  function resolveLocationMapping(query, locationMappings) {
    var matches = (locationMappings || [])
      .map(function (mapping) {
        var scored = scoreMapping(query, mapping);
        var hub = mapping.hub;
        var geoLocation =
          mapping.lat !== null && mapping.lng !== null
            ? {
                name: mapping.displayName || mapping.searchCity,
                state: mapping.state,
                stateCode: mapping.stateCode,
                lat: mapping.lat,
                lng: mapping.lng,
              }
            : null;

        return {
          kind: scored.kind,
          score: scored.score,
          mapping: mapping,
          hubs: hub && hub.url ? [hub] : [],
          hub: hub && hub.url ? hub : null,
          geoLocation: geoLocation,
        };
      })
      .filter(function (match) {
        return match.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });

    return matches[0] || null;
  }

  function findNearestCityHub(lat, lng, cityHubs) {
    return (
      (cityHubs || [])
        .filter(function (hub) {
          return hub.lat !== null && hub.lng !== null;
        })
        .map(function (hub) {
          return Object.assign({}, hub, {
            distance: calculateDistanceMiles(lat, lng, hub.lat, hub.lng),
          });
        })
        .sort(function (a, b) {
          return a.distance - b.distance;
        })[0] || null
    );
  }

  function getHubMatches(query, cityHubs) {
    var normalizedQuery = normalizeSearchValue(query);
    var compactQuery = compactSearchValue(query);
    var stateQuery = getStateQuery(query);

    if (!normalizedQuery) return [];

    return (cityHubs || [])
      .map(function (hub) {
        var hubText = getHubSearchText(hub);
        var hubCompact = compactSearchValue(hubText);
        var score = 0;

        if (compactSearchValue(hub.title) === compactQuery) {
          score = 100;
        } else if (
          stateQuery &&
          (normalizeSearchValue(hub.state) === stateQuery ||
            usStateNames[normalizeSearchValue(hub.stateCode)] === stateQuery)
        ) {
          score = 70;
        } else if (normalizedQuery.length >= 2 && hubText.indexOf(normalizedQuery) !== -1) {
          score = 60;
        } else if (normalizedQuery.length >= 3 && normalizedQuery.indexOf(hubCompact) !== -1) {
          score = 55;
        }

        return Object.assign({}, hub, {
          score: score,
        });
      })
      .filter(function (hub) {
        return hub.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });
  }

  window.CityGuideSearchUtils = {
    normalizeSearchValue: normalizeSearchValue,
    compactSearchValue: compactSearchValue,
    splitList: splitList,
    toNumber: toNumber,
    calculateDistanceMiles: calculateDistanceMiles,
    getStateQuery: getStateQuery,
    normalizeUrl: normalizeUrl,
    parseCityHubs: parseCityHubs,
    parseLocationMappings: parseLocationMappings,
    resolveLocationMapping: resolveLocationMapping,
    findNearestCityHub: findNearestCityHub,
    getHubMatches: getHubMatches,
    isLikelyInternationalQuery: function () {
      return false;
    },
  };
})();
